import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function ManageSearchIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12166_135395" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12166_135395)"><path d="M3.33203 31.6667V29.1667H19.9987V31.6667H3.33203ZM3.33203 22.9167V20.4167H11.6654V22.9167H3.33203ZM3.33203 14.1667V11.6667H11.6654V14.1667H3.33203ZM34.9154 31.6667L28.2487 25C27.5265 25.5556 26.7487 25.9722 25.9154 26.25C25.082 26.5278 24.2209 26.6667 23.332 26.6667C21.0265 26.6667 19.0612 25.8542 17.4362 24.2292C15.8112 22.6042 14.9987 20.6389 14.9987 18.3333C14.9987 16.0278 15.8112 14.0625 17.4362 12.4375C19.0612 10.8125 21.0265 10 23.332 10C25.6376 10 27.6029 10.8125 29.2279 12.4375C30.8529 14.0625 31.6654 16.0278 31.6654 18.3333C31.6654 19.2222 31.5265 20.0833 31.2487 20.9167C30.9709 21.75 30.5543 22.5278 29.9987 23.25L36.6654 29.9167L34.9154 31.6667ZM23.322 24.1667C24.9398 24.1667 26.3181 23.6006 27.457 22.4683C28.5959 21.3358 29.1654 19.9608 29.1654 18.3433C29.1654 16.7256 28.5993 15.3472 27.467 14.2083C26.3345 13.0694 24.9595 12.5 23.342 12.5C21.7243 12.5 20.3459 13.0661 19.207 14.1983C18.0681 15.3308 17.4987 16.7058 17.4987 18.3233C17.4987 19.9411 18.0648 21.3194 19.197 22.4583C20.3295 23.5972 21.7045 24.1667 23.322 24.1667Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon viewBox="0 0 40 40" {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}